export default __webpack_public_path__ + "images/0dcd13fae1fb18b144994a09523e466e.png";